import { TFunction } from 'i18next'
import { OnboardingStep } from 'types/onboardingTypes'

export function getBMI(t: TFunction): OnboardingStep {
  return {
    id: 'bmi',
    type: 'custom',
    allowNext: true,
    wordings: {
      title: t('')
    }
  }
}
